import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { OrganizationSchema, WebSiteSchema, WebPageSchema, FAQPageSchema } from '@/components/feature/SchemaOrg';
import { siteInfo, faqs } from '@/mocks/home';
import HeroSection from './components/HeroSection';
import StatsSection from './components/StatsSection';
import CategorySection from './components/CategorySection';
import FeaturedSection from './components/FeaturedSection';
import LatestSection from './components/LatestSection';
import FAQSection from './components/FAQSection';
import TestimonialSection from './components/TestimonialSection';
import NewsletterSection from './components/NewsletterSection';

export default function Home() {
  return (
    <>
      <OrganizationSchema />
      <WebSiteSchema />
      <WebPageSchema
        title="奶水动漫 - 专属母婴哺乳主题动漫内容平台"
        description={siteInfo.description}
        url="https://www.naishuidongman.com/"
      />
      <FAQPageSchema faqs={faqs} />
      <Navbar />
      <main>
        <HeroSection />
        <StatsSection />
        <CategorySection />
        <FeaturedSection />
        <LatestSection />
        <FAQSection />
        <TestimonialSection />
        <NewsletterSection />
      </main>
      <Footer />
    </>
  );
}